module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_utsunomiya-a5553b45019a5d6ef51a1ff567fb6973.jpg";